<template>
  <div class="list-filters__advanced">
    <b-row>
      <b-col class="text-center filter-actions mb-3" v-if="withReset || withSave">
        <b-badge role="link" size="md" v-if="withReset" @click="resetAdvancedFilters" v-translate>Reset Filters</b-badge>
        <b-badge role="link" size="sm" v-if="withSave && !noQuerystring" @click="saveCurrentAdvancedFilters" v-translate>Save this Filters' Set</b-badge>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form @submit.prevent="emitFilters(index)" v-if="filterFields && filterField && advancedFilters && preFilters.indexOf(filter) === -1" horizontal label="Filter" :label-cols="1" class="mb-0" v-for="(filter, index) in advancedFilters" :key="index">
          <b-input-group class="mb-1">
            <b-form-select :options="filterFields" v-model="advancedFilters[index][0]" />
            <b-form-select :options="filterOptions" v-model="advancedFilters[index][1]" />
            <b-form-input v-model="advancedFilters[index][2]" :placeholder="$gettext('Type to Search')" v-if="advancedFilters[index][1] !== 'in'" />
            <b-form-input v-model="inArrayValues[index]" @change="inArray(index)" :placeholder="$gettext('option 1,option 2, etc.')" v-if="advancedFilters[index][1] === 'in'" />
            <b-input-group-append>
              <b-button :disabled="!advancedFilters[index][2]" type="submit" v-translate>Apply</b-button>
              <b-button @click="deleteFilter(index)" variant="danger">✕</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-form @submit.prevent="addFilter()" v-if="filterFields && filterField && advancedFilters && preFilters.indexOf(filter) === -1" horizontal label="Filter" :label-cols="1" class="mb-0">
          <b-input-group class="mb-1">
            <b-form-select :options="filterFields" v-model="newFilter[0]" />
            <b-form-select :options="filterOptions" v-model="newFilter[1]" />
            <b-form-input v-model="newFilter[2]" :placeholder="$gettext('Type to Search')" v-if="newFilter[1] !== 'in'" />
            <b-form-input v-model="inArrayNewValues" :placeholder="$gettext('option 1,option 2, etc.')" v-if="newFilter[1] === 'in'" />
            <b-input-group-append>
              <b-button :disabled="!newFilter[2]" type="submit" v-translate>Apply</b-button>
              <b-button disabled variant="danger">✕</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  name: 'AdvancedFilters',
  props: {
    preFilters: {
      type: Array,
      default: () => {
        return []
      }
    },
    model: {
      type: Object,
      required: true
    },
    withReset: {
      type: Boolean,
      default: true
    },
    withSave: {
      type: Boolean,
      default: true
    },
    noQuerystring: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      advancedFilters: [],
      filterFields: [],
      filterField: '',
      filterOption: 'ct',
      filterText: null,
      filter: [],
      inArrayValues: [],
      newFilter: [],
      inArrayNewValues: ''
    }
  },
  computed: {
    filterOptions() {
      return [
        {
          value: 'ct',
          text: this.$gettext('Contains')
        },
        {
          value: 'sw',
          text: this.$gettext('Starts with')
        },
        {
          value: 'ew',
          text: this.$gettext('Ends with')
        },
        {
          value: 'eq',
          text: this.$gettext('Equals')
        },
        {
          value: 'gt',
          text: this.$gettext('Greater than')
        },
        {
          value: 'gte',
          text: this.$gettext('Greater than or equalTo')
        },
        {
          value: 'lte',
          text: this.$gettext('Lesser than or equalTo')
        },
        {
          value: 'lt',
          text: this.$gettext('Lesser than')
        },
        {
          value: 'in',
          text: this.$gettext('In array')
        },
        {
          value: 'bt',
          text: this.$gettext('Between')
        }
      ]
    }
  },
  watch: {
    inArrayNewValues(val) {
      const values = val.split(',')
      for (let i = 0; i < values.length; i++) {
        values[i] = values[i].trim()
      }
      this.newFilter[2] = values
    },
    filterFields(val) {
      if (val) {
        this.filterField = val[0]
        this.newFilter = [this.filterField, 'ct', '']
      }
    },
    '$language.current': {
      handler() {
        this.$nextTick(() => {
          this.filterFields = this.model.filters.map(filter => {
            if (filter.text && filter.value) {
              return filter
            }
            return {
              value: filter,
              text: this.model.fields.findIndex(x => x.key === filter && x.label) !== -1 ? this.model.fields.find(x => x.key === filter).label : filter
            }
          })
        })
      },
      deep: true
    },
    '$route.query': {
      immediate: true,
      handler(newVal) {
        // Update advancedFilters if QS was modified by ColumnFilters
        this.advancedFilters = []
        this.filterFields = this.model.filters.map(filter => {
          if (filter.text && filter.value) {
            return filter
          }
          return {
            value: filter,
            text: this.model.fields.findIndex(x => x.key === filter && x.label) !== -1 ? this.model.fields.find(x => x.key === filter).label : filter
          }
        })
        this.filterField = this.filterFields[0].value
        this.newFilter = [this.filterField, 'ct', '']
        if (newVal.af && !this.noQuerystring) {
          const hashedAdvancedFilters = this.advancedFilters.map(x => JSON.stringify(x))
          const queryFilters = JSON.parse(newVal.af)
          for (let i = 0; i < queryFilters.length; i++) {
            if (hashedAdvancedFilters.indexOf(JSON.stringify(queryFilters[i])) === -1) {
              this.advancedFilters.push(queryFilters[i])
              if (queryFilters[i][1] === 'in') {
                this.inArrayValues[i] = [...new Set(queryFilters[i][2])]
                this.inArrayValues[i].join()
              }
            }
          }
        }
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.advancedFilters = this.advancedFilters.concat(this.preFilters)
      this.init()
    })
  },
  methods: {
    init() {
      this.filterFields = this.model.filters.map(filter => {
        if (filter.text && filter.value) {
          return filter
        }
        return {
          value: filter,
          text: this.model.fields.findIndex(x => x.key === filter && x.label) !== -1 ? this.model.fields.find(x => x.key === filter).label : filter
        }
      })
      this.filterField = this.filterFields[0].value
      this.newFilter = [this.filterField, 'ct', '']
      if (this.$route.query.af && !this.noQuerystring) {
        const hashedAdvancedFilters = this.advancedFilters.map(x => JSON.stringify(x))
        const queryFilters = JSON.parse(this.$route.query.af)
        for (let i = 0; i < queryFilters.length; i++) {
          if (hashedAdvancedFilters.indexOf(JSON.stringify(queryFilters[i])) === -1) {
            this.advancedFilters.push(queryFilters[i])
            if (queryFilters[i][1] === 'in') {
              this.inArrayValues[i] = [...new Set(queryFilters[i][2])]
              this.inArrayValues[i].join()
            }
          }
        }
        this.emitFilters()
      }
    },
    inArray(index) {
      const values = this.inArrayValues[index].split(',')
      for (let i = 0; i < values.length; i++) {
        values[i] = values[i].trim()
      }
      this.advancedFilters[index][2] = values
    },
    formatFilter() {
      return [this.filterField, this.filterOption, this.filter]
    },
    emitFilters() {
      // this.advancedFilters = this.advancedFilters.concat(this.preFilters)
      this.advancedFilters = [...new Set(this.advancedFilters)]
      if (!this.noQuerystring) {
        this.$router.push({ query: this.advancedFilters.length > 0 ? { af: JSON.stringify(this.advancedFilters) } : null })
      }
      this.$emit('filtering', { filtersToEmit: this.advancedFilters })
    },
    addFilter() {
      this.advancedFilters.push(this.newFilter)
      if (this.newFilter[1] === 'in') {
        this.inArrayValues.push(this.newFilter[2].join())
      }
      this.newFilter = [this.filterFields[0], 'ct', '']
      this.inArrayNewValues = ''
      this.emitFilters()
    },
    deleteFilter(index) {
      this.advancedFilters.splice(index, 1)
      this.inArrayValues.splice(index, 1)
      if (!this.noQuerystring) {
        this.$router.push({ query: this.advancedFilters.length > 0 ? { af: JSON.stringify(this.advancedFilters) } : null })
      }
      this.$emit('filtering', { filtersToEmit: this.advancedFilters })
    },
    resetData() {
      this.advancedFilters = []
    },
    saveCurrentAdvancedFilters() {
      this.$emit('save-filter')
    },
    resetAdvancedFilters() {
      this.$emit('reset')
      this.advancedFilters = this.preFilters
      if (!this.noQuerystring) {
        this.$router.push({ query: null })
      }
      this.emitFilters()
    }
  }
}
</script>

<style lang="scss" scoped>
  .form-control {
    height: 2.25rem;
    border-width: 1px !important;
  }
  .custom-select {
    margin-right: 5px;
  }
</style>
